import { render, staticRenderFns } from "./ResetToken.vue?vue&type=template&id=bd3d8bfc&scoped=true"
import script from "./ResetToken.vue?vue&type=script&lang=js"
export * from "./ResetToken.vue?vue&type=script&lang=js"
import style0 from "./ResetToken.vue?vue&type=style&index=0&id=bd3d8bfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd3d8bfc",
  null
  
)

export default component.exports